import * as Types from '../graphql.generated';

export type GetAgentsQueryVariables = Types.Exact<{
    url: Types.Scalars['String'];
}>;

export type GetAgentsQuery = { __typename?: 'Query' } & {
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & {
                text: Types.Breadcrumbs['label'];
                id: Types.Breadcrumbs['tracking'];
                href: Types.Breadcrumbs['uri'];
            }
        >
    >;
    agents:
        | ({ __typename: 'AgentsSearchConnection' } & Pick<
              Types.AgentsSearchConnection,
              'locationDisplayName' | 'total'
          > & {
                  results: Array<
                      { __typename: 'Agent' } & Pick<
                          Types.Agent,
                          | 'displayName'
                          | 'id'
                          | 'name'
                          | 'uriName'
                          | 'displayAddress'
                          | 'featured'
                          | 'contactNumber'
                      > & {
                              listingsStatistics?: Types.Maybe<
                                  { __typename?: 'ListingsStatistics' } & {
                                      residential?: Types.Maybe<
                                          {
                                              __typename?: 'ListingStatisticsByType';
                                          } & {
                                              forSale?: Types.Maybe<
                                                  {
                                                      __typename?: 'ListingsStatisticsData';
                                                  } & Pick<
                                                      Types.ListingsStatisticsData,
                                                      | 'avgAskingPrice'
                                                      | 'avgWeeksOnMarket'
                                                      | 'availableListings'
                                                  >
                                              >;
                                              toRent?: Types.Maybe<
                                                  {
                                                      __typename?: 'ListingsStatisticsData';
                                                  } & Pick<
                                                      Types.ListingsStatisticsData,
                                                      | 'avgAskingPrice'
                                                      | 'avgWeeksOnMarket'
                                                      | 'availableListings'
                                                  >
                                              >;
                                          }
                                      >;
                                      commercial?: Types.Maybe<
                                          {
                                              __typename?: 'ListingStatisticsByType';
                                          } & {
                                              forSale?: Types.Maybe<
                                                  {
                                                      __typename?: 'ListingsStatisticsData';
                                                  } & Pick<
                                                      Types.ListingsStatisticsData,
                                                      | 'avgAskingPrice'
                                                      | 'avgWeeksOnMarket'
                                                      | 'availableListings'
                                                  >
                                              >;
                                              toRent?: Types.Maybe<
                                                  {
                                                      __typename?: 'ListingsStatisticsData';
                                                  } & Pick<
                                                      Types.ListingsStatisticsData,
                                                      | 'avgAskingPrice'
                                                      | 'avgWeeksOnMarket'
                                                      | 'availableListings'
                                                  >
                                              >;
                                          }
                                      >;
                                  }
                              >;
                              logo?: Types.Maybe<
                                  { __typename?: 'AgentLogoData' } & Pick<
                                      Types.AgentLogoData,
                                      'height' | 'width' | 'uri'
                                  >
                              >;
                          }
                  >;
                  pagination: { __typename?: 'AgentsSearchPagination' } & Pick<
                      Types.AgentsSearchPagination,
                      'pageNumber' | 'pageTotal'
                  >;
              })
        | ({ __typename: 'AgentsSearchResponseError' } & {
              errors: Array<
                  { __typename?: 'AgentsSearchErrorMessage' } & Pick<
                      Types.AgentsSearchErrorMessage,
                      'code' | 'message' | 'path'
                  >
              >;
          });
    user?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.User, 'loggedIn'>>;
};

export const GetAgentsDocument = `
    query GetAgents($url: String!) {
  breadcrumbs(path: $url) {
    text: label
    id: tracking
    href: uri
  }
  agents(url: $url) {
    ... on AgentsSearchConnection {
      __typename
      results {
        __typename
        displayName
        id
        name
        uriName
        displayAddress
        featured
        listingsStatistics {
          residential {
            forSale {
              avgAskingPrice
              avgWeeksOnMarket
              availableListings
            }
            toRent {
              avgAskingPrice
              avgWeeksOnMarket
              availableListings
            }
          }
          commercial {
            forSale {
              avgAskingPrice
              avgWeeksOnMarket
              availableListings
            }
            toRent {
              avgAskingPrice
              avgWeeksOnMarket
              availableListings
            }
          }
        }
        logo {
          height
          width
          uri
        }
        contactNumber
      }
      pagination {
        pageNumber
        pageTotal
      }
      locationDisplayName
      total
    }
    ... on AgentsSearchResponseError {
      __typename
      errors {
        code
        message
        path
      }
    }
  }
  user {
    loggedIn
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        GetAgents(
            variables: GetAgentsQueryVariables,
            options?: C
        ): Promise<GetAgentsQuery> {
            return requester<GetAgentsQuery, GetAgentsQueryVariables>(
                GetAgentsDocument,
                variables,
                options
            );
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
